import React from "react";
import { MapPin } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { Reveal, Eyebrow } from "./Reveal";
import { IMAGES } from "@/constants/site";

export const About = () => {
  const { t } = useLanguage();

  return (
    <section id="chi-siamo" className="relative py-24 sm:py-32 bg-cream overflow-hidden">
      <span
        aria-hidden="true"
        className="pointer-events-none select-none absolute -top-8 right-0 font-serif italic text-[11rem] sm:text-[17rem] leading-none text-stroke-ghost opacity-60"
      >
        01
      </span>

      <div className="relative max-w-[1200px] mx-auto px-6 grid lg:grid-cols-12 gap-12 lg:gap-16 items-center">
        <Reveal className="lg:col-span-5">
          <div className="relative">
            <div className="frame-arch overflow-hidden border border-gold/40 bg-warm p-2.5 shadow-[0_20px_40px_-15px_rgba(59,10,17,0.15)]">
              <img
                src={IMAGES.about}
                alt="Aperitivo al banco: panino al salmone e cocktail della casa"
                loading="lazy"
                className="frame-arch w-full h-[380px] sm:h-[520px] object-cover"
              />
            </div>
            <div className="absolute -bottom-5 right-4 sm:-right-2 flex items-center gap-2 rounded-full border border-gold/40 bg-cream/90 backdrop-blur-md px-5 py-2.5 shadow-[0_10px_30px_-10px_rgba(59,10,17,0.25)]">
              <MapPin className="w-4 h-4 text-terracotta" />
              <span className="text-[11px] font-mono uppercase tracking-[0.2em] text-burgundy">{t.about.badge}</span>
            </div>
          </div>
        </Reveal>

        <div className="lg:col-span-7">
          <Reveal>
            <Eyebrow>{t.about.chapter}</Eyebrow>
          </Reveal>
          <Reveal delay={0.08}>
            <h2 className="mt-4 font-serif text-3xl sm:text-4xl lg:text-5xl tracking-tight leading-[1.08] text-ink">
              {t.about.title}
            </h2>
          </Reveal>
          <Reveal delay={0.16}>
            <p className="mt-7 text-base sm:text-lg font-light leading-relaxed text-stone-600">{t.about.p1}</p>
          </Reveal>
          <Reveal delay={0.22}>
            <p className="mt-5 text-base sm:text-lg font-light leading-relaxed text-stone-600">{t.about.p2}</p>
          </Reveal>
          <Reveal delay={0.3}>
            <blockquote className="mt-9 border-l-2 border-gold pl-6 font-serif italic text-xl sm:text-2xl text-burgundy leading-snug">
              {t.about.quote}
            </blockquote>
          </Reveal>
        </div>
      </div>
    </section>
  );
};
